/* @flow */

export default class DownloadCommissionReportRequest {
  companyId: number;
  format: string;
  type: string;
  isoCompanyIds: number[];
  isoOfficeIds: number[];
  isoPersonIds: number[];
  periodDateFrom: string;
  periodDateTo: string;

  constructor(companyId: number, format: string, type: string) {
    this.companyId = companyId;
    this.format = format;
    this.type = type;
    this.isoCompanyIds = [];
    this.isoOfficeIds = [];
    this.isoPersonIds = [];
    this.periodDateFrom = null;
    this.periodDateTo = null;
  }

  toRouteParameters() {
    let route = `companyId=${this.companyId}&format=${this.format}&type=${this.type}`;

    this.isoCompanyIds.forEach(isoCompanyId => {
      route += `&isoCompanyIds=${isoCompanyId}`;
    });
    this.isoOfficeIds.forEach(isoOfficeId => {
      route += `&isoOfficeIds=${isoOfficeId}`;
    });
    this.isoPersonIds.forEach(isoPersonId => {
      route += `&isoPersonIds=${isoPersonId}`;
    });
    if (this.periodDateFrom && this.periodDateTo) {
      route += `&periodDateFrom=${this.periodDateFrom}&periodDateTo=${this.periodDateTo}`;
    }

    return route;
  }
}
